import api from "./Api";

class AdicionalGrupoItemService {
  GetAdicionalGrupoItem(payload) {
    return api.get("/v1/adicionalGrupoItem/" + payload).then((response) => {
      return response.data;
    });
  }

  PostAdicionalGrupoItem(payload) {
    return api.post("/v1/adicionalGrupoItem/", payload).then((response) => {
      return response.data;
    });
  }

  PutAdicionalGrupoItem(payload) {
    return api.put("/v1/adicionalGrupoItem/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteAdicionalGrupoItem(payload) {
    return api.delete("/v1/adicionalGrupoItem/" + payload).then((response) => {
      return response.data;
    });
  }

  GetAdicionalGrupoItemOData(payload) {
    return api.get("/OData/AdicionalGrupoItem" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new AdicionalGrupoItemService();
